import { type Analytics, getAnalytics, isSupported, setAnalyticsCollectionEnabled } from 'firebase/analytics'
import { initializeApp } from 'firebase/app'
import { initializeAppCheck, ReCaptchaEnterpriseProvider } from 'firebase/app-check'
import { connectAuthEmulator, getAuth } from 'firebase/auth'
import { connectFirestoreEmulator, getFirestore } from 'firebase/firestore'
import { connectStorageEmulator, getStorage } from 'firebase/storage'
import { getStoredAnalyticsOptOut } from '@/services/usage/consent'

const firebaseConfig = {
  apiKey: 'AIzaSyA2PURwdhN5VAh4EiM6SUbxwaqcvYNXLvo',
  authDomain: 'parsley-dev-180cd.firebaseapp.com',
  projectId: 'parsley-dev-180cd',
  storageBucket: 'parsley-dev-180cd.firebasestorage.app',
  messagingSenderId: '691013150737',
  appId: '1:691013150737:web:820d7d699fc9fabda7e9b0',
  measurementId: 'G-1WE33XBT50'
}

export const app = initializeApp(firebaseConfig)

// App Check reCAPTCHA Enterprise SCORE-BASED site key. Public + domain-locked (ships in the
// client) — same class as the firebaseConfig keys above. Registered for parsley-dev-180cd.
const RECAPTCHA_ENTERPRISE_SITE_KEY = '6Lc9J0UtAAAAAFH5T1yDXOzXkFiEOPRaq5WWNoTC'

// App Check attaches a client attestation token to every Firestore / Storage / callable request.
// A debug token must be set BEFORE init; dev only initializes when one is present, since the emulator
// suite doesn't enforce App Check.
const appCheckDebugToken = import.meta.env.VITE_APPCHECK_DEBUG_TOKEN
if (appCheckDebugToken) {
  ;(globalThis as { FIREBASE_APPCHECK_DEBUG_TOKEN?: string }).FIREBASE_APPCHECK_DEBUG_TOKEN = appCheckDebugToken
}
if (!import.meta.env.DEV || appCheckDebugToken) {
  initializeAppCheck(app, {
    provider: new ReCaptchaEnterpriseProvider(RECAPTCHA_ENTERPRISE_SITE_KEY),
    isTokenAutoRefreshEnabled: true
  })
}

export const auth = getAuth(app)
export const db = getFirestore(app)
export const storage = getStorage(app)

// Analytics — only in production (no emulator for analytics)
export let analytics: Analytics | null = null
const isDevelopment = import.meta.env.DEV
if (!isDevelopment) {
  isSupported().then((supported) => {
    if (supported) {
      analytics = getAnalytics(app)
      // Honor a device-stored opt-out from a previous session before any events fire.
      // AnalyticsConsentContext re-applies (and reconciles with Firestore) once auth resolves.
      if (getStoredAnalyticsOptOut()) setAnalyticsCollectionEnabled(analytics, false)
    }
  })
}

// Connect to emulators in development
if (isDevelopment) {
  // Only connect once - these functions throw if called multiple times
  try {
    connectAuthEmulator(auth, 'http://localhost:9099', { disableWarnings: true })
    connectFirestoreEmulator(db, 'localhost', 8081)
    connectStorageEmulator(storage, 'localhost', 9199)
    console.log('🔧 Connected to Firebase emulators')
  } catch (_error) {
    // Emulators already connected
  }
}
